export default {
  // 搜索和过滤
  modelNamePlaceholder: '模型名称',
  refreshImages: '刷新图片',
  selectAll: '全选',
  deselectAll: '取消全选',
  reasoning: '推理',

  // 提示信息
  selectionHint: '共 {count} 张，勾选后点击推理',
  reasoningWithCount: '推理（已选 {count}）',
  emptyDescription: '暂无图片，请点击刷新',

  // 消息提示
  noImagesFound: '未查询到图片',
  queryImagesFailed: '查询图片失败',
  pleaseSelectImages: '请先选择图片',
  reasoningCompleted: '推理完成',
}
